import { ContactForm } from "../components/ContactForm";
import { CTA, Hero } from "../components/Section";
import { contactDetails } from "../content/site";
import { workImageSets } from "../content/workImages";

export function ContactPage() {
  return (
    <>
      <Hero
        images={workImageSets.contactHero}
        title="Bring the plans, specifications, or fabrication challenge."
        copy="Contact Metalworks & Design Group for estimating, detailing, fabrication, finishing, and installation support. Whether you need a competitive bid, a constructability review, custom fabrication, or project coordination, our team is ready to help. We work closely with contractors, developers, and project managers to provide practical solutions, accurate pricing, and field-ready metalwork that keeps projects on schedule."
      />
      <section className="contact-top section-pad" data-reveal>
        <div className="contact-details">
          {contactDetails.map((detail) => {
            const Icon = detail.icon;
            return (
              <article key={detail.label}>
                <Icon size={20} />
                <div>
                  <h3>{detail.label}</h3>
                  <p>{detail.value}</p>
                </div>
              </article>
            );
          })}
        </div>
        <ContactForm />
      </section>
      <CTA
        title="Need a quick answer?"
        copy="Submit your question, material requirements, or project details, and we'll point you in the right direction."
        label="Send Details"
        href="/contact"
      />
    </>
  );
}
